import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { setToken } from "../../../Utils/token";
import { getParameterByName, hideLoader, showLoaderGuest } from "../../../Utils";
import { V6USERS } from "../../../Utils/constants";

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

// const getParameterByName = (name, url = window.location.href) => {
//     name = name.replace(/[\[\]]/g, '\\$&');
//     var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
//         results = regex.exec(url);
//     if (!results) return null;
//     if (!results[2]) return '';
//     return decodeURIComponent(results[2]);
// }

const BlankPage = (props) => {

    const query = useQuery();
    const key = getParameterByName("agg_key");//query.get("agg_key");
    const token = getParameterByName("token");//query.get("agg_key");
    const app_name = getParameterByName("app_name") || "q2";//query.get("agg_key");
    const iframe = getParameterByName("iframe") || "true";//query.get("agg_key");

    const [authenticating, setauthenticating] = useState(false);
    const [initLoad, setinitLoad] = useState(true);

    let intervalCheck = null;

    useEffect(() => {
        if (key && key.length > 0 && app_name == "q2") {
            sessionStorage.setItem("access_token", token);
            sessionStorage.setItem("q2_token", key);
            showLoaderGuest();
            setauthenticating(true);
            validateTokenQ2();
        } else if (key && key.length > 0 && app_name == "banno") {
            let access_token = localStorage.getItem("access_token");
            if (access_token) {
                sessionStorage.setItem("access_token", access_token);
            }
            sessionStorage.setItem("banno_token", key);

            showLoaderGuest();
            setauthenticating(true);
            validateTokenBanno();
        } else if (token && token.length > 0) {
            sessionStorage.setItem("access_token", token);
            sessionStorage.setItem("q2_token", token);
            setToken(token);
            showLoaderGuest();
            setauthenticating(true);
            validateToken();
        }
    }, [key])

    const validateToken = () => {

        hideLoader();
        props._user(V6USERS + "?module=q2", "", (res) => {
            clearInterval(intervalCheck);
            props.history.push("/parent/dashboard");
        })
    }

    const validateTokenQ2 = () => {

        setTimeout(() => {
            setinitLoad(false);
        }, 2000);
        //console.log(encodeURIComponent(key));

        props._q2Integration(`integrations/status?token=${encodeURIComponent(key)}`, {}, (res, status) => {

            // intervalCheck = setInterval(() => {
            //     validateTokenQ2();
            // }, 2000);

            if (status === 207) {
                hideLoader();
                props.history.push({ pathname: `/complete/profile`, state: res })
            } else if (res && res.key) {
                hideLoader();
                setToken(res.key);
                props._user(V6USERS + "?module=q2", "", (res) => {
                    clearInterval(intervalCheck);
                    props.history.push("/parent/dashboard");
                })
            } else {
                showLoaderGuest();
                setTimeout(() => {
                    validateTokenQ2();
                }, 3500)
            }

        }, err => {
            setTimeout(() => {
                showLoaderGuest();
                validateTokenQ2();
            }, 1000);

            //alert(`error in logging in...`)
        })
    }

    const validateTokenBanno = () => {
        //setToken(key);
        try {
            const regoToken = encodeURIComponent(key.replaceAll(/"/g, ''));
            setToken(regoToken);
            props._user(V6USERS + "?module=q2", "", (res) => {
                clearInterval(intervalCheck);
                if (iframe === "false") {
                    props.history.push("/parent/dashboard");
                } else {
                    props.history.push("/parent/child/card");
                }
            })

            // props._q2Integration(`banno/integrations/status?token=${}`, {}, (res, status) => {
            //     if (status === 207) {
            //         hideLoader();
            //         props.history.push({ pathname: `/complete/profile`, state: res })
            //     } else if (res && res.key) {
            //         hideLoader();
            //         setToken(res.key);
            //         props._user(V6USERS + "?module=q2", "", (res) => {
            //             clearInterval(intervalCheck);
            //             if(iframe === "false"){
            //                 props.history.push("/parent/dashboard");
            //             }else{
            //                 props.history.push("/parent/child/card");
            //             }
            //         })
            //     } else {
            //         showLoaderGuest();
            //         setTimeout(() => {
            //             validateToken();
            //         }, 3500)
            //     }
            // }, err => {
            //     setTimeout(() => {
            //         showLoaderGuest();
            //         validateToken();
            //     }, 1000);
            // })
        } catch (err) {
            console.log(err);
        }

        // props._user(V6USERS+"?module=banno", "", (res) => {
        //     hideLoader();
        //     if(iframe === "false"){
        //         props.history.push("/parent/dashboard");
        //     }else{
        //         props.history.push("/parent/child/card");
        //     }
        //     //props.history.push("/parent/child/card");
        // })
    }

    return (
        <>
            {authenticating &&
                <div className="external-connecting-bank-msg text-center">
                    {initLoad ?
                        <div className="wrapper">
                            <h1>Loading...</h1>
                        </div>
                        : <div className="wrapper">
                            <h1>We are setting up your Family Wallet</h1>
                            <h4 className="grey-subtitle">It can take up to 2 minutes</h4>
                        </div>
                    }
                </div>
            }
        </>
    );
}

export default BlankPage;